import HttpService from "../base/HttpService";
export default class ManagementContractService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;
  getDataContract(param) {
    const api = this.api + "management-contract/report";

    return this.get(param, api);
  }
  getDataSummaryContract(param) {
    const api = this.api + "management-contract/summary";

    return this.get(param, api);
  }
  getDataSummaryContractDetail(param) {
    const api = this.api + "management-contract/summary-detail";

    return this.get(param, api);
  }
}
